import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async save_shift_allocations(data) {
    let response = await apiCall(
      "shifts_allocations/create_shift_allocations",
      data
    );
    return response;
  },
  async get_users_with_allocations(data) {
    let response = await apiCall(
      "shifts_allocations/list_shift_allocation",
      data
    );
    return response;
  },
  async update_fuel_category(data) {
    let response = await apiCall(
      "fuel_categories/update_fuel_station_group",
      data
    );
    return response;
  },
};
